import { FC, useContext, useEffect, useState } from "react";

import PracticeField from "./treatingReferringFields/practiceField";
import DoctorField from "./treatingReferringFields/doctorField";
import AnesthesiologyGroup from "./treatingReferringFields/anesthesiology";

import { AuthContext } from "src/context/authContext";
import usePatientDetailFunc from "src/hooks/usePatientDetailFunc";
import useTreatingPracAndDocFunc from "src/hooks/useTreatingPracAndDocFunc";
import useReferringPracAndDocFunc from "src/hooks/useReferringPracAndDocFunc";

import { IOveraOnStepTwoProps } from "./types";
import { isFieldRequired } from "src/helpers/addCase";
// import { AddCaseSchema } from "src/validation/addCase";
import { CaseContext } from "src/context/caseContext";




const HCPUserOptions: FC<IOveraOnStepTwoProps> = ({ control, watch, setValue, trigger, getValues }): JSX.Element => {
  const [firstTreatedPractice] = useState(getValues("doctor_attributes.treating_practice_id"))
  const [firstTreatedDoctor] = useState(getValues("doctor_attributes.treating_doctor_id"))
  const [firstReferringPractice] = useState(getValues("doctor_attributes.referring_practice_id"))
  const [firstReferringDoctor] = useState(getValues("doctor_attributes.referring_doctor_id"))

  const { userData } = useContext(AuthContext)
  const { caseSchema } = useContext(CaseContext)
  const is_anesthesiologist = watch("doctor_attributes.is_anesthesiologist")
  const iAm = watch("doctor_attributes.i_am");
  // setValue("doctor_attributes.is_anesthesiologist",is_anesthesiologist)
  const globalPatientId = watch("patient_attributes.global_patient_id");

  const treatingPracticeId = watch("doctor_attributes.treating_practice_id")
  const treatingDoctorId = watch("doctor_attributes.treating_doctor_id")
  const referringPracticeId = watch("doctor_attributes.referring_practice_id")
  const referringDoctorId = watch("doctor_attributes.referring_doctor_id")

  usePatientDetailFunc(globalPatientId, setValue, trigger, getValues)
  const {
    isPracAPILoading: treatingPracLoading,
    globalDoctorsApiResponse: treatingDocResponse,
    practiceListing: treatingPracticeListing,
    getPracticeListing: getTreatingPracListing,
    clearPracticeListing: clearTreatingPracListing,
    getDoctorListingByPracticeId: getTreatingDoctorListingByPracticeId,
    doctorPracListing, 
    doctorPracLoading,
    getDebouncedDoctorPracListingByQuery: getDoctorPracListingByQuery,
  } = useTreatingPracAndDocFunc(getValues, watch, setValue)
  const {
    isPracAPILoading: referringPracLoading,
    globalDoctorsApiResponse: referringDocResponse,
    practiceListing: referringPracticeListing,
    getPracticeListing: getreferringPracListing,
    clearPracticeListing: clearReferringPracListing,
    getReferringDoctorListingByPracticeId
  } = useReferringPracAndDocFunc(getValues, watch, setValue)

  useEffect(() => {
    if (iAm) {
      if (["Treating Provider", "Treating Facility"].includes(iAm)) {
        getreferringPracListing("_", true)
        if (userData && ["Practice", "Contact"].includes(userData.ref_type)) {
          // getDoctorPracListingByQuery(iAm !== "Treating Provider" ? "_" : "", true)
          getTreatingPracListing(iAm === "Treating Provider" ? "_" : "", true)
        } else
          getTreatingPracListing("", true)
      } else if (["Referring Provider", "Referring Facility"].includes(iAm)) {
        getreferringPracListing("", true)
        getTreatingPracListing("_", true)
      } else {
        getTreatingPracListing("", true)
        getreferringPracListing("", true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iAm])

  useEffect(() => {
    if (treatingPracticeId) {
      const selectedPractice = treatingPracticeListing?.data.find((prac) => prac.id === treatingPracticeId)
      if (selectedPractice) setValue("practice_name", selectedPractice.name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatingPracticeId])

  useEffect(() => {
    if (treatingDoctorId) {
      trigger("doctor_attributes.treating_doctor_id")
      const selectedDoctor = treatingDocResponse?.data.find((doc) => doc.id === treatingDoctorId)
      if (selectedDoctor) {
        setValue("doctor_fullname", selectedDoctor.fullname)
        setValue("doctor_firstlastname", selectedDoctor.first_last_name)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatingDoctorId])


  useEffect(() => {
    if (iAm === "Referring and Treating Facility") {
      if (treatingDoctorId !== 0 && referringPracticeId !== 0 && !is_anesthesiologist)
        setValue("doctor_attributes.referring_doctor_id",treatingDoctorId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iAm, treatingDoctorId])

  useEffect(() => {
    if (typeof is_anesthesiologist === "boolean") {
      if (is_anesthesiologist) {
        getDoctorPracListingByQuery(iAm !== "Treating Provider" ? "_" : "", true)
        if (iAm === "Treating Provider")
          getTreatingPracListing("_", true)
      } else {
        getTreatingDoctorListingByPracticeId(["Treating Provider"].includes(iAm) ? 0 : treatingPracticeId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_anesthesiologist])




  let fields = <></>;
  switch(iAm) {
    case "Treating Provider":
      fields = (
        <>
          {userData && ["Practice", "Contact"].includes(userData.ref_type) ? (
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="treating_provider_5"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  shouldDisable={true}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="treating_provider_6"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={0}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
              <PracticeField
                mode="treating_provider_4"
                shouldReset={treatingPracticeId !== firstTreatedPractice}
                shouldBeAbleToSearch={true}
                isAPILoading={treatingPracLoading}
                control={control}
                fieldName="doctor_attributes.treating_practice_id"
                getPracticeListing={getTreatingPracListing}
                pracListing={treatingPracticeListing}
                setValue={setValue}
                dontResetDoctorField={true}
                watch={watch}
                isCancellable={true}
                trigger={trigger}
              />
            </>
          ) : (
            <PracticeField
              mode="treating_provider_1"
              shouldReset={treatingPracticeId !== firstTreatedPractice}
              shouldBeAbleToSearch={false}
              isAPILoading={treatingPracLoading}
              control={control}
              fieldName="doctor_attributes.treating_practice_id"
              getPracticeListing={getTreatingPracListing}
              pracListing={treatingPracticeListing}
              setValue={setValue}
              watch={watch}
              trigger={trigger}
            />
          )}
          <PracticeField
            mode="treating_provider_2"
            shouldReset={referringPracticeId !== firstReferringPractice}
            shouldBeAbleToSearch={true}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            clearPracListing={clearReferringPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.referring_practice_id") ? (
            <DoctorField
              mode="treating_provider_3"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={caseSchema ? isFieldRequired(caseSchema, "doctor_attributes.treating_doctor_id", iAm) : true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          ) : null}
          
        </>
      )
      break;
    case "Treating Facility":
      fields = (
        <>
          {userData && ["Practice", "Contact"].includes(userData.ref_type) ? (
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="treating_provider_1"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="treating_provider_1"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          ) : (
            <DoctorField
              mode="treating_facility_1"
              shouldReset={firstTreatedDoctor !== treatingDoctorId}
              control={control}
              fieldName="doctor_attributes.treating_doctor_id"
              isRequired={true}
              docListing={treatingDocResponse}
              practice_id={getValues("doctor_attributes.treating_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          )}

          <PracticeField
            mode="treating_facility_2"
            shouldReset={referringPracticeId !== firstReferringPractice}
            shouldBeAbleToSearch={true}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            clearPracListing={clearReferringPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.referring_practice_id") ? (
            <DoctorField
              mode="treating_facility_3"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={caseSchema ? isFieldRequired(caseSchema, "doctor_attributes.treating_doctor_id", iAm) : true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          ) : null}
        </>
      )
      break;
    case "Referring Provider":
      fields = (
        <>
          <PracticeField
            mode="referring_provider_1"
            shouldReset={referringPracticeId !== firstReferringPractice}
            isAPILoading={referringPracLoading}
            shouldBeAbleToSearch={false}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          />
          <PracticeField
            mode="referring_provider_2"
            shouldReset={treatingPracticeId !== firstTreatedPractice}
            shouldBeAbleToSearch={true}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            clearPracListing={clearTreatingPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.treating_practice_id") ? (
            <DoctorField
              mode="referring_provider_3"
              shouldReset={firstTreatedDoctor !== treatingDoctorId}
              control={control}
              fieldName="doctor_attributes.treating_doctor_id"
              isRequired={true}
              docListing={treatingDocResponse}
              practice_id={getValues("doctor_attributes.treating_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          ) : null}
        </>
      )
      break;
    case "Referring Facility":
      fields = (
        <>
          <DoctorField
            mode="referring_facility_1"
            shouldReset={firstReferringDoctor !== referringDoctorId}
            control={control}
            fieldName="doctor_attributes.referring_doctor_id"
            isRequired={true}
            docListing={referringDocResponse}
            practice_id={getValues("doctor_attributes.referring_practice_id")}
            setValue={setValue}
            getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
            watch={watch}
            trigger={trigger}
          />
          <PracticeField
            mode="referring_facility_2"
            shouldReset={treatingPracticeId !== firstTreatedPractice}
            shouldBeAbleToSearch={true}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            clearPracListing={clearTreatingPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {userData && ["Practice", "Contact"].includes(userData.ref_type) ? (
            <>
              {getValues("doctor_attributes.treating_practice_id") ? (
                <>
                  <AnesthesiologyGroup control={control} />
                  {is_anesthesiologist === true ? (
                    <PracticeField
                      mode="referring_facility_4"
                      shouldReset={treatingDoctorId !== firstTreatedDoctor}
                      shouldBeAbleToSearch={true}
                      isAPILoading={doctorPracLoading}
                      control={control}
                      fieldName="doctor_attributes.treating_doctor_id"
                      getPracticeListing={getDoctorPracListingByQuery}
                      pracListing={doctorPracListing}
                      setValue={setValue}
                      watch={watch}
                      isCancellable={true}
                      trigger={trigger}
                    />
                  ) : (
                    <DoctorField
                      mode="referring_facility_3"
                      shouldReset={firstTreatedDoctor !== treatingDoctorId}
                      control={control}
                      fieldName="doctor_attributes.treating_doctor_id"
                      isRequired={true}
                      docListing={treatingDocResponse}
                      practice_id={getValues("doctor_attributes.treating_practice_id")}
                      setValue={setValue}
                      getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
                      watch={watch}
                      trigger={trigger}
                    />
                  )}
                </>
              ) : null}
            </>
          ) : null}
        </>
      )
      break;
    case "Referring and Treating Facility":
      fields = (
        <>
          {userData && ["Practice", "Contact"].includes(userData.ref_type) ? 
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="referring_and_treating_facility_1"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="referring_and_treating_facility_1"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getTreatingDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
            : null
          }
          {getValues("doctor_attributes.referring_practice_id") ? (
            <DoctorField
              mode="referring_and_treating_facility_2"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          ) : null}
        </>
      )
      break;
    default:
      fields = <></>
  }

  return fields;
}

export default HCPUserOptions
